import React, { Component } from 'react';
import { Tabs, Button, message, Select } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
//import SearchRetrieve from '../../common/SearchRetrieve.new.js';
const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

class Filter extends Component {


    handleChange = (params, key) => {
        if (key === 'investigationAreaId') {
            //const { areaOptions } = this.props;
            //const { label } = (areaOptions || []).find(i => i.value == params['investigationAreaId']) || {};
            //params.investigationAreaName = label;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    getDeptFilter = () => {
        const {activeKey} = this.props;
        let filters = [];
        if (activeKey == 'queryRegion') {
            filters = {
                name: '科室',
                key: 'departmentName',
                type: 'input',
            };
        } else {
            filters = {};
        }
        return filters;
    }

    render() {
        
        const {activeKey, areaOptions, businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        //const { activeKey } = this.props.state;
        const filters = [
            {
                name: '医院',
                key: 'hospital',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'hospitalName',
                    style: {width: 160},
                    placeholder: '输入名称检索',
                    params: {limit: 20},
                    url: API_URL.hospital.hospitalList,
                    config: { id: 'hospitalId', name: 'hospitalName' }
                }
            }, 
            this.getDeptFilter(),
            {
                name: '项目领域',
                key: 'investigationAreaId',
                type: 'select',
                typeProperty: {
                    allowClear: true,
                    list: areaOptions,
                },
            },
            {
                name: '领域leader',
                key: 'leaderUser',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'keyword',
                    style: {width: 140},
                    placeholder: '输入姓名/工号检索',
                    params: {limit: 20},
                    url: API_URL.user.queryLeaderList,
                    config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
                }
            }, 
            {
                name: '业务线',
                key: 'lineOfBusiness',
                type: 'select',
                typeProperty: {
                    list: businessOption,
                }
            }
        ];
        
        return (
            
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class QueryRegion extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            businessList: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryAreaHospitalCRC,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                type: 'REGION',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { searchParams: { investigationAreaName = '' } } = this.state;
        const columns = [{
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            fixed: 'left',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            fixed: 'left',
            width: 90,
        }, {
            title: '医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 120,
        }, {
            title: '科室',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            width: 80,
        }, {
            title: '津石同期CRC人数',
            dataIndex: 'hospitalCrcNum',
            key: 'hospitalCrcNum',
            width: 90,
        }, {
            title: 'CRC工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 120,
        }, {
            title: 'CRC姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byCrc"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class QueryInvArea extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryAreaHospitalCRC,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                type: 'INV_AREA',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { searchParams: { investigationAreaName = '' } } = this.state;
        const columns = [{
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            fixed: 'left',
            width: 80,
        }, {
            title: '津石同期CRC人数',
            dataIndex: 'hospitalCrcNum',
            key: 'hospitalCrcNum',
            fixed: 'left',
            width: 90,
        }, {
            title: '医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 120,
        }, {
            title: '当前领域下，分布在此医院的CRC人数',
            dataIndex: 'invAreaHospitalCrcNum',
            key: 'invAreaHospitalCrcNum',
            width: 80,
        }, {
            title: 'CRC工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 130,
        }, {
            title: 'CRC姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byDepartment"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class AreaHospitalCRC extends Component {
    state = {
        panes: [{
            title: '各医院CRC的科室分布',
            key: 'queryRegion',
            content: null,
        }, {
            title: '各领域CRC的医院分布',
            key: 'queryInvArea',
            content: null,
        }],
        activeKey: 'queryRegion',
        searchParams: {
            end: moment().format(monthFormat),
        },
        curParams: {
            end: moment().format(monthFormat),
        },
        areaOptions: [],
        businessList: [],
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    loadAreaList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllInvestigationArea,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { curParams, searchParams } = this.state;
                const areaOptions = (res.data || []).map(item => {
                    const { investigationAreaId, investigationAreaName } = item;
                    // if (investigationAreaName === '肿瘤') {
                    //     curParams.investigationAreaId = investigationAreaId + '';
                    //     curParams.investigationAreaName = investigationAreaName;
                    //     searchParams.investigationAreaId = investigationAreaId + '';
                    //     searchParams.investigationAreaName = investigationAreaName;
                    // }
                    return {
                        label: investigationAreaName,
                        value: investigationAreaId,
                    };
                });
                this.setState({
                    areaOptions,
                    curParams,
                    searchParams,
                }, () => {
                    this.updatePanes();
                });
            }
        };
        $.sendRequest(options);
    }

    search = () => {
        const { searchParams } = this.state;
        this.setState({
            curParams: {...searchParams}
        }, () => {
            const { curParams } = this.state;
            this.childRef.search(curParams);
        });
    }

    export = () => {
        const { activeKey, sortParams, curParams } = this.state;
        const type = (activeKey === 'queryRegion' && 'REGION') || (activeKey === 'queryInvArea' && 'INV_AREA');
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportInvAreaByCRC,
            data: {
                ...sortParams,
                ...curParams,
                offset: 1,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    updatePanes = () => {
        const { panes, activeKey, curParams } = this.state;
        let RenderContent = null;
        if (activeKey == 'queryRegion') {
            RenderContent = QueryRegion;
        } else if (activeKey == 'queryInvArea') {
            RenderContent = QueryInvArea;
        } 
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent ref={el => this.childRef = el} searchParams={curParams} />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
        }, () => {
            this.updatePanes();
        });
    }

    render() {
        const { exportable } = this.props;
        const { panes, activeKey, areaOptions, searchParams, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <div style={{marginTop: 20, marginBottom: 4, float:'fixed'}}>
                <Filter
                    search={this.search}
                    params={searchParams}
                    businessList={businessList}
                    areaOptions={areaOptions}
                    activeKey={activeKey}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                </div>
                
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{pane.content}</TabPane>)}
                </Tabs>
            </div>
        );
    }
}

export default AreaHospitalCRC;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/areaHospitalCRC.js